import axios from "axios";

export default {
  namespaced: true,
  state: {
    purchaseorders: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    purchaseordersMessage: ''
  },
  mutations: {
    RECEIVED_PURCHASEORDERS(state, payload) {
      state.purchaseorders = payload;
      state.isReceiving = false;
    },
    RECEIVING_PURCHASEORDERS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVING_PURCHASEORDER(state) {
      state.isReceiving = true;
    },
    RECEIVED_PURCHASEORDER(state, payload) {
      let find = state.purchaseorders.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { purchaseorders: [payload, ...state.purchaseorders] });
      }
      else {
        let index = state.purchaseorders.findIndex(x => x._id==payload._id);
        state.purchaseorders.splice(index, 1, payload);
      }
    },

    UPDATED_PURCHASEORDERS(state, payload) {
      console.log(state.purchaseorders);
      console.log(payload);
      let index = state.purchaseorders.findIndex(purchaseorder => purchaseorder._id === payload._id);
      state = Object.assign(state, {
        purchaseorders: state.purchaseorders.map((purchaseorder, i) => {
          if (i === index) {
            return Object.assign({}, purchaseorder, payload);
          }
          return purchaseorder;
        }),
        isUpdating: false,
        purchaseordersMessage: 'PurchaseOrders has been updating!',
      })
    },
    UPDATING_PURCHASEORDERS(state) {
      state.isUpdating = true;
    },
    DELETED_PURCHASEORDERS(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.purchaseorders.findIndex(purchaseorder => purchaseorder._id === payload._id);
      console.log(indexToDelete);
      let purchaseorders = [...state.purchaseorders];
      purchaseorders.splice(indexToDelete, 1);
      state = Object.assign(state, {
        purchaseorders: [...purchaseorders],
        isDeleting: false,
        idToDelete: null,
        purchaseordersMessage: 'PurchaseOrder has been Deleted!',
      });
    },
    DELETING_PURCHASEORDERS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async insertPurchaseOrderRequest({dispatch}, payload) {
      dispatch("receivingPurchaseOrders");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/purchaseorder';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      var post = {method: "post",url: url, headers: headers, data: data};
      return axios(post)
      .then(response=> {dispatch("receivePurchaseOrder", response.data);})
      .catch((error) => {this.alertmessage = error;});	
    },
    async insertPOTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let id = payload.id;
        delete payload['id'];
        let token = localStorage.getItem("token");
        console.log(token);
        console.log(payload)
        let url = "https://api.tradexc.com:3000/insert/potransaction/" + id;
        console.log(url)
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        console.log(response.data);
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    deletePurchaseOrderRequest({dispatch}, payload) {
      dispatch("deletingPurchaseOrder", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/purchaseorder/' + payload._id;
      let header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      let del = {
        method: "delete",
        url: url,
        headers: header,
      };

      axios(del)
      .then(response=>{
        dispatch("deletePurchaseOrder", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deletePOTransactionRequest({dispatch}, id) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/potransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async getPurchaseOrdersRequest({dispatch}) {
      dispatch("receivingPurchaseOrders");
      let token = localStorage.getItem('token');
      console.log(token);
      let url = 'https://api.tradexc.com:3000/get/purchaseorders';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(res => {
        dispatch("receivePurchaseOrders", res.data);
      })
    },
    async getPurchaseOrderRequest({dispatch}, id) {
      dispatch("receivingPurchaseOrders");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/purchaseorder/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: header});
      dispatch("receivePurchaseOrder", response.data);
      return response.data;
    },
    async findPurchaseOrdersRequest({dispatch}, payload) {
      try{
        dispatch("receivingPurchaseOrders");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/purchaseorders';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receivePurchaseOrders", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updatePurchaseOrderRequest({dispatch}, payload) {
      dispatch("updatingPurchaseOrder");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/purchaseorder/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers,data: payload})
      .then((response)=> {
        dispatch("updatePurchaseOrder", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updatePOTradeRequest({dispatch}, payload) {
      dispatch("updatingPurchaseOrder");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/purchaseorder/trade/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "put",url: url,headers: headers,data: payload})
      .then((response)=> {
        dispatch("updatePurchaseOrder", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updatePOTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        var id = payload.id;
        delete payload['id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/update/potransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "put", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    receivePurchaseOrders({commit}, payload) {
      commit("RECEIVED_PURCHASEORDERS", payload)
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receivingPurchaseOrders({commit}) {
      commit("RECEIVING_PURCHASEORDERS")
    },
    receivePurchaseOrder({commit}, payload) {
      commit("RECEIVED_PURCHASEORDER", payload)
    },
    receivingPurchaseOrder({commit}) {
      commit("RECEIVING_PURCHASEORDERS")
    },
    updatePurchaseOrder({commit}, payload) {
      commit("UPDATED_PURCHASEORDERS", payload)
    },
    updatingPurchaseOrder({commit}) {
      commit("UPDATING_PURCHASEORDERS")
    },
    deletePurchaseOrder({commit}, payload) {
      commit("DELETED_PURCHASEORDERS", payload)
    },
    deletingPurchaseOrder({commit}, payload) {
      commit("DELETING_PURCHASEORDERS", payload)
    }
  },
};
